<template>
    <div class="p-5 position-content-main">
        <div class="breadcrumbnewtheme pb-3">
            <div class="pre gap-0p5 fw-500">
                Tickets
            </div>
            <span style="color:#b2bec3">/</span>
            <div class="pre gap-0p5 fw-500">
                Overall
            </div>
            <span style="color:#b2bec3">/</span>
            <span class="curr gap-0p5 fw-500">
                List View
            </span>
        </div>
        <hr>
    </div>
</template>

<script>

export default{
    data() {
        return {

        }
    },
    methods: {

    },
    computed: {

    },
    mounted(){

    },
    created(){

    }
}
</script>

<style scoped>
.gap-0p5{
    gap: 0.5rem;
}
.breadcrumbnewtheme{
    display: flex;
    align-items: center;
    gap: 1rem;
    border-bottom: 2px solid #636e71;
}
.breadcrumbnewtheme div{
    color: #00448b;
}
.fs-2rem{
    font-size: 2rem;
}
.position-content-main{
    border-radius: 25px;
    background-color: #f0ddb7;
}
</style>